import {
  api,
  apiClientAuthenticated,
  apiClientUnauthenticated,
  apiCorilusPassport
} from "./base-config";
import { TenantOption } from "common/dto/TenantOption";
import { mapToUserModel } from "api/dto/UserDTO";

export const getEHealthPassword = async (
  idToken: string,
  corilusPersonId: string,
  keyStorePasswordKey: string,
  tenant: string
) => {
  const config = {
    headers: {
      practice: tenant
    }
  };
  apiCorilusPassport.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${idToken}`;

  return apiCorilusPassport
    .get(
      `/api/resources/users/${corilusPersonId}/keyringentry/${keyStorePasswordKey}`,
      config
    )
    .then(response => {
      return response.data.keyValue;
    });
};

export const createStsSession = async (
  userId: number,
  eHealthPassword: string
): Promise<string> => {
  return api
    .post(`/resources/secured/rs/caregivers/${userId}/sts/token`, {
      "@type": "STSTokenRequest",
      ehealthPassword: eHealthPassword
    })
    .then(response => response.data.token);
};

export const fetchTenants = async (
  idToken: string
): Promise<Array<TenantOption>> => {
  const data = new URLSearchParams();
  data.append("id_token", idToken);

  return apiClientUnauthenticated
    .post("/oauth/tenants", data.toString())
    .then(response => response.data);
};

export const loginWithToken = async (
  idToken: string,
  tenant: string
): Promise<any> => {
  const config = {
    headers: {
      practice: tenant
    }
  };
  const data = new URLSearchParams();
  data.append("grant_type", "mfa_token");
  data.append("practice", tenant);
  data.append("token", idToken);
  data.append("uuid", "ccef41b2-308c-4bd5-b812-2d5edee0a296");

  return apiClientAuthenticated
    .post("/resources/oauth/token", data.toString(), config)
    .then(response => {
      return { ...response.data, user: mapToUserModel(response.data.user) };
    });
};
